import {MOCKUPS_PREVIEWS_LOCALES} from "./localeVariables";

const isLocalisedMockupPreview = (locale) => {
    return MOCKUPS_PREVIEWS_LOCALES.find(code => code === locale);
}

export default isLocalisedMockupPreview;
